import {Routes} from '@angular/router';
import {IndexComponent} from './index/index';
import {authenticationGuardActivate} from './authentication/authentication.guard';
import {profileGuardMatch} from './profile/profile.guard';

export const routes:Routes=[
	{
		path:'error',
		loadComponent:()=>import('./error/error').then(m=>m.ErrorComponent),
		pathMatch:'full',
		data:{preload:true}
	},
	{
		path:'',
		component:IndexComponent,
		pathMatch:'full'
	},
	{
		path:'login',
		component:IndexComponent,
		pathMatch:'full',
		canActivate:[authenticationGuardActivate]
	},
	{
		path:'signup',
		component:IndexComponent,
		pathMatch:'full',
		canActivate:[authenticationGuardActivate]
	},
	{
		path:'forgot-password',
		component:IndexComponent,
		pathMatch:'full',
		canActivate:[authenticationGuardActivate]
	},
	{
		path:'login-phone',
		component:IndexComponent,
		pathMatch:'full',
		canActivate:[authenticationGuardActivate]
	},
	{
		path:'2fa',
		component:IndexComponent,
		pathMatch:'full',
		canActivate:[authenticationGuardActivate]
	},
	{
		path:'reset-password',
		loadChildren:()=>import('./reset-password/reset-password.routes').then(m=>m.routes),
		data:{preload:true}
	},
	{
		path:'email-verified',
		loadComponent:()=>import('./email-verified/email-verified').then(m=>m.EmailVerifiedComponent),
		pathMatch:'full',
		data:{preload:true}
	},
	{
		path:'profile',
		loadChildren:()=>import('./profile/profile.routes').then(m=>m.routes),
		canMatch:[profileGuardMatch]
	},
	{
		path:'contact',
		loadComponent:()=>import('./contact/contact').then(m=>m.ContactComponent),
		pathMatch:'full',
		data:{preload:true}
	},
	{
		path:'privacy-policy',
		loadComponent:()=>import('./privacy-policy/privacy-policy').then(m=>m.PrivacyPolicyComponent),
		pathMatch:'full',
		data:{preload:true}
	},
	{
		path:'terms-of-use',
		loadComponent:()=>import('./terms-of-use/terms-of-use').then(m=>m.TermsOfUseComponent),
		pathMatch:'full',
		data:{preload:true}
	},
	{
		path:'products',
		loadChildren:()=>import('./products/products.routes').then(m=>m.routes),
		data:{preload:true}
	},
	{
		path:'tecnicas-modernas-de-cultivo',
		loadComponent:()=>import('./tecnicas-modernas-de-cultivo/tecnicas-modernas-de-cultivo').then(m=>m.TecnicasModernasDeCultivoComponent),
		pathMatch:'full',
		data:{preload:true}
	},
	{
		path:'clasificacion-de-semillas-de-cannabis',
		loadComponent:()=>import('./clasificacion-de-semillas-de-cannabis/clasificacion-de-semillas-de-cannabis').then(m=>m.ClasificacionDeSemillasDeCannabisComponent),
		pathMatch:'full',
		data:{preload:true}
	},
	{
		path:'envios',
		loadComponent:()=>import('./envios/envios').then(m=>m.EnviosComponent),
		pathMatch:'full',
		data:{preload:true}
	},
	{
		path:'cart',
		loadComponent:()=>import('./cart/cart').then(m=>m.CartComponent),
		pathMatch:'full',
		data:{preload:true}
	},
	{
		path:'check-out',
		loadChildren:()=>import('./check-out/check-out.routes').then(m=>m.routes),
		data:{preload:true}
	},
	{
		path:'tracking',
		loadComponent:()=>import('./tracking/tracking').then(m=>m.TrackingComponent),
		data:{preload:true}
	},
	{
		path:'blog',
		loadChildren:()=>import('./blog/blog.routes').then(m=>m.routes),
		data:{preload:true}
	},
	{
		path:'search',
		loadChildren:()=>import('./search/search.routes').then(m=>m.routes),
		data:{preload:true}
	},
	{
		path:'**',
		loadComponent:()=>import('./not-found/not-found').then(m=>m.NotFoundComponent),
		data:{preload:true}
	}
];
